import React from 'react'
import { ApplicationFlowTheme, RegisterProtocol } from '../types'
import useRegisterSkinController, { RegisterSubmission } from './hooks/use-register-skin-controller'
import RegisterSkin from './register-skin'

interface Props {

  /** 已由渠道配置解析出的对客品牌名称。 */
  brandName: string

  /** 是否使用聚好借的品牌标识展示方式。 */
  isJhjBrand: boolean

  /** 返回意图，始终交由旧注册业务决定。 */
  onBack: () => void

  /** 打开注册、隐私或个人信息协议的业务回调。 */
  onOpenProtocol: (protocol: RegisterProtocol) => void

  /** 发送验证码的旧业务回调；成功时返回 true。 */
  onRequestCode: (phone: string) => Promise<boolean>

  /** 提交手机号和验证码的旧业务回调；成功时返回 true。 */
  onSubmitRegister: (submission: RegisterSubmission) => Promise<boolean>

  /** 当前渠道模板唯一决定的主题与资源。 */
  theme: ApplicationFlowTheme
}

/**
 * RegisterSkinContainer — 组装注册皮肤本地交互与旧业务回调的边界
 * @returns {React.ReactElement} 可直接挂载的注册皮肤
 */
const RegisterSkinContainer: React.FC<Props> = React.memo(({
  brandName,
  isJhjBrand,
  onBack,
  onOpenProtocol,
  onRequestCode,
  onSubmitRegister,
  theme,
}) => {
  const controller = useRegisterSkinController({
    onRequestCode,
    onSubmitRegister,
  })

  return (
    <RegisterSkin
      model={{
        brandName,
        isJhjBrand,
        ...controller.model,
      }}
      onBack={onBack}
      onChangeAmount={controller.onChangeAmount}
      onChangeCode={controller.onChangeCode}
      onChangePeriod={controller.onChangePeriod}
      onChangePhone={controller.onChangePhone}
      onCloseAgreementDialog={controller.onCloseDialog}
      onCloseCodeDialog={controller.onCloseDialog}
      onConfirmAgreement={controller.onConfirmAgreement}
      onOpenProtocol={onOpenProtocol}
      onRequestCode={controller.onRequestCode}
      onSubmit={controller.onSubmit}
      onToggleAgreement={controller.onToggleAgreement}
      onValidatePhone={controller.onValidatePhone}
      theme={theme}
    />
  )
})

RegisterSkinContainer.displayName = 'RegisterSkinContainer'

export default RegisterSkinContainer
